import { LocalStorage } from './../../core/helper/localStorage';
import { Component, OnInit } from '@angular/core';

import { List } from 'linqts';
import { AppConstants } from "../../app.constant";
import { Broadcast } from "../../core/events/broadcast";
import { utConstants } from "../ut/ut.constants";
import { MenusService } from "../forms/utmenus/utmenus.service";
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';



@Component({
	moduleId: module.id,
	selector: 'sidebar-left',
	templateUrl: '../shell-templates/sidebar-left.component.html'
})

export class SidebarLeftComponent {
	//menusList: Array<any>;
	menuid: any;
	menus: Array<any>;
	tree: Array<any>;


	title = 'Navigation Menu';
	protected broadcast: Broadcast;
	returnmenuid: number;

	constructor(private menusService: MenusService, private router: Router, private route: ActivatedRoute) {
		this.broadcast = AppConstants.injector.get(Broadcast);
	}

	async ngOnInit() {
		await this.getMenu();

		this.route.queryParams.subscribe(params => {
			this.returnmenuid = Number(params.menuid);

		});
	}

	getSubMenu(event, menutype: number) {
		if (menutype == 1) {
			this.broadcast.publish<string>('submenu', '');
			this.broadcast.publish<string>('menu', event.currentTarget.innerText);
		}
		else if (menutype == 2)
			this.broadcast.publish<string>('submenu', event.currentTarget.innerText);

	}

	async getMenu() {
		const dto = await this.menusService.getMenu();
		if (dto.IsSuccess) {
			this.tree = dto.Data;
		}
		else {
			console.log(dto.Errors);
		}
	}

	generateTree(pid: any): any[] {
		const treedata: any = [];

		const plist = this.menus.filter(o => pid == undefined ? !o.parentid : o.parentid == pid);

		const lst = (new List<any>(plist).OrderBy(o => o.menuindex)).ToArray();

		lst.forEach(element => {
			const itm: any = {};
			itm.caption = element.caption;
			if (element.utscreen) {
				itm.utscreen = element.utscreen;
				itm.screencode = element.utscreen.screencode;
			}
			const child = this.generateTree(element.menuid);
			if (child) {
				itm.children = child;
			}
			treedata.push(itm);

		});
		return treedata;
	}

	getID(event) {
		if (event.currentTarget.id === "dashboard") {
			this.router.navigate(['home']);
		}
		else if (event.currentTarget.id) {
			this.menuid = event.currentTarget.id;
			let navigationExtras: NavigationExtras = {
				queryParams: {
					menuid: this.menuid,
					menucollection: JSON.stringify(this.tree)
				},
				replaceUrl: false
			};
			this.router.navigate(['menuscreen'], navigationExtras);
		}
	}

}













// WEBPACK FOOTER //
// ./src/app/shell/shell-components/sidebar-left.component.ts